import { render, staticRenderFns } from "./DetalhesBudgetLider.vue?vue&type=template&id=cee6ea04&"
import script from "./DetalhesBudgetLider.vue?vue&type=script&lang=js&"
export * from "./DetalhesBudgetLider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports